import React, { useMemo } from 'react';

import { Box, Flex, Icon, Td, Text } from '@chakra-ui/react';
import { FaAngleRight } from 'react-icons/fa';

import { GetComponentParams } from '../../../PayoffDealsTable/components/ColumnComponents';
import ConfirmPayoffFailure from '../../../PayoffDealsTable/components/ColumnComponents/ConfirmPayoffFailure';

import { getUnseenMessageNotificationsCount } from '../../../../constants/notifications';
import { useUser } from '../../../../hooks/useUser';
import { CopyButton } from '../../../CopyButton/CopyButton';
import TextNotificationBadgeV2 from '../../../NotificationBadge/TextNotificationBadgeV2';

const Name = ({ deal, payoffRequest, collapsed, setCollapsed, value }: GetComponentParams) => {
  const user = useUser();
  const unseenNotificationsCount = useMemo(
    () => getUnseenMessageNotificationsCount(user.id, { notifications: deal.notifications }),
    [user.id, deal.notifications],
  );

  const handleClick = (e: React.MouseEvent<SVGElement, MouseEvent>) => {
    e.stopPropagation();

    if (setCollapsed) {
      setCollapsed(!collapsed);
    }
  };

  const confirmPayoffFailureModalButton = payoffRequest ? (
    <ConfirmPayoffFailure payoffRequest={payoffRequest} />
  ) : null;

  return (
    <Td
      pl={payoffRequest ? '2rem' : '2.5rem'}
      position="relative"
      borderBottomWidth="1px"
      borderColor="gray.100"
    >
      <Flex alignItems="center">
        <Flex ml="-1.25rem" mr="0.25rem">
          <CopyButton
            value={`${window.location.origin}/deals/${deal.id}`}
            isFormatted
            visibility={!!deal.id && !!payoffRequest}
          />
        </Flex>
        <Box position="absolute" left="0.5rem">
          <TextNotificationBadgeV2 count={unseenNotificationsCount} deal={deal} />
        </Box>
        {confirmPayoffFailureModalButton}
        <Icon
          as={FaAngleRight}
          transform={collapsed ? 'rotate(0deg)' : 'rotate(90deg)'}
          transition="transform 0.2s"
          marginRight={4}
          onClick={handleClick}
        />
        <Text>{value}</Text>
      </Flex>
    </Td>
  );
};

export default Name;
